import { render, staticRenderFns } from "./ToogleButtons.vue?vue&type=template&id=a40aa522&scoped=true&"
import script from "./ToogleButtons.vue?vue&type=script&lang=js&"
export * from "./ToogleButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToogleButtons.vue?vue&type=style&index=0&id=a40aa522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40aa522",
  null
  
)

export default component.exports